import { Component, Input, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TabListComponent, TabComponent } from '@kelyn-technologies/dsio-angular-lib';

import { TenantEntitlementsComponent } from '../tenant-entitlements/tenant-entitlements.component';
import { TenantOperationsComponent } from '../tenant-operations/tenant-operations.component';
import { TenantSolutionsComponent } from '../tenant-solutions/tenant-solutions.component';

@Component({
  selector: 'app-tenant-detail',
  templateUrl: './tenant-detail.component.html',
  imports: [
    MatTabsModule,
    TenantSolutionsComponent,
    TenantEntitlementsComponent,
    TenantOperationsComponent,
    RouterModule,
    TabListComponent,
    TabComponent,
  ],
  styleUrls: ['./tenant-detail.component.css'],
})
export class TenantDetailComponent implements OnInit {
  @Input() public tenantId = '';
  @Input() public componentId = '';
  @Input() public constructId = '';
  @Input() public correlationId = '';
  constructor(public route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const tenantId = params['tenantId'];
      this.tenantId = typeof tenantId === 'string' ? tenantId : '';
      this.componentId = typeof params['componentId'] === 'string' ? params['componentId'] : '';
      this.constructId = typeof params['constructId'] === 'string' ? params['constructId'] : '';
      this.correlationId = typeof params['correlationId'] === 'string' ? params['correlationId'] : '';
    });
  }
}
